import { Avatar } from 'antd';
import type { AvatarProps } from 'antd';
import { useEffect, useState } from 'react';
import defaultAvatar from 'assets/images/default-avatar.png';
import { SERVER_FILE_ENDPOINT } from 'constants/envs';

/** Ảnh gà mặc định — cùng ảnh với app (HP-Media assets/image/source/avatar.png). */
export const DEFAULT_AVATAR: string = defaultAvatar;

type UserAvatarProps = Omit<AvatarProps, 'src' | 'icon' | 'children'> & {
  /** Khoá ảnh tương đối (profile.avatar) hoặc URL đầy đủ */
  src?: string | null;
};

const toUrl = (src?: string | null) => {
  if (!src) return '';
  if (/^(https?:|data:|blob:)/i.test(src)) return src;
  return `${SERVER_FILE_ENDPOINT}/${src.replace(/^\/+/, '')}`;
};

/**
 * Ảnh đại diện của một NGƯỜI: có ảnh thì hiện ảnh; trống hoặc tải lỗi thì hiện ảnh gà
 * mặc định cho tới khi người dùng tự đặt ảnh. Nhóm / Studio / Agency không dùng cái này
 * (giữ chữ cái để không trông giống một người).
 */
export default function UserAvatar({ src, ...rest }: UserAvatarProps) {
  const url = toUrl(src);
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [url]);
  return (
    <Avatar
      {...rest}
      src={url && !failed ? url : DEFAULT_AVATAR}
      onError={() => {
        setFailed(true);
        return false;
      }}
    />
  );
}
